import './launchCards.scss';

export const LaunchCardsTemplate = (model) => {
	const { exploreMore, brandName } = model;

	/* html */
	const html = `
		<div class="engt-launch-cards" id="engtLaunchCards">
			<span class="engt-launch-cards-title">
				<label class="engt-text" id="exploreMore">${exploreMore}${brandName}...</label>
				<span class="dots"><carousel-dots></carousel-dots></span>
			</span>
			<carousel></carousel>
		</div>
    `;

	return html;
};
